import _ from "lodash";
import { useEffect, useMemo, useState } from "react";

// ローディングのチラつき防止
export const useDebounceLoading = (fetching: boolean) => {
  const [loading, setLoading] = useState<boolean>(fetching);
  const debounceHideLoading = useMemo(() => _.debounce(() => setLoading(false), 300), []);
  useEffect(() => (fetching ? setLoading(fetching) : debounceHideLoading()), [fetching]);

  return { loading };
};
